import {
  SurgeonsApiClient,
  createSurgeonsApiClient,
} from '@peritasai/data-access';
import type {
  CreateSurgeonDto,
  PaginatedSurgeonsResponseDto,
  SurgeonDto,
  SurgeonsFilterParams,
  UpdateSurgeonDto,
} from '@peritasai/types';
import { SurgeonEntity } from './surgeon.entity';

export interface ISurgeonsRepository {
  getSurgeonsPaginated(
    options: SurgeonsFilterParams
  ): Promise<PaginatedSurgeonsResponseDto & { surgeons: SurgeonEntity[] }>;
  createSurgeon(dto: CreateSurgeonDto): Promise<SurgeonEntity>;
  updateSurgeon(id: string, dto: UpdateSurgeonDto): Promise<SurgeonEntity>;
}

export class SurgeonsRepository implements ISurgeonsRepository {
  constructor(private readonly apiClient: SurgeonsApiClient) {}

  async getSurgeonsPaginated(
    options: SurgeonsFilterParams = {}
  ): Promise<PaginatedSurgeonsResponseDto & { surgeons: SurgeonEntity[] }> {
    const response = await this.apiClient.getSurgeons(options);
    return {
      ...response,
      surgeons: response.data.map((dto) => this.toEntity(dto)),
    };
  }

  async createSurgeon(dto: CreateSurgeonDto): Promise<SurgeonEntity> {
    const result = await this.apiClient.createSurgeon(dto);
    return this.toEntity(result);
  }

  async updateSurgeon(id: string, dto: UpdateSurgeonDto): Promise<SurgeonEntity> {
    const result = await this.apiClient.updateSurgeon(id, dto);
    return this.toEntity(result);
  }

  private toEntity(dto: SurgeonDto): SurgeonEntity {
    return new SurgeonEntity(dto);
  }
}

export const surgeonsRepository = new SurgeonsRepository(createSurgeonsApiClient());
